export default (eventsUid) => {
    return useFetchWithTanstackQuery({
        queryKey: ['eventDetail', eventsUid],
        queryFn: () => $fetch(`/api/center/events/${eventsUid}`),
        options: {
            staleTime: 5 * 60 * 1000 // 5 min
        }
    })
}
